/**
 * @flow
 * @relayHash 138c71c85197e4d828d820b2c694d98f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BankAccountVerification_bankAccount$ref = any;
export type BankAccountDividendPayoutUpdateMutationVariables = {|
  bankAccountId: string,
  dividendPayout: boolean,
|};
export type BankAccountDividendPayoutUpdateMutationResponse = {|
  +updateBankAccountDividendPayout: ?{|
    +bankAccount: ?{|
      +$fragmentRefs: BankAccountVerification_bankAccount$ref
    |}
  |}
|};
export type BankAccountDividendPayoutUpdateMutation = {|
  variables: BankAccountDividendPayoutUpdateMutationVariables,
  response: BankAccountDividendPayoutUpdateMutationResponse,
|};
*/


/*
mutation BankAccountDividendPayoutUpdateMutation(
  $bankAccountId: ID!
  $dividendPayout: Boolean!
) {
  updateBankAccountDividendPayout(dividendPayout: $dividendPayout, bankAccountId: $bankAccountId) {
    bankAccount {
      ...BankAccountVerification_bankAccount
      id
    }
  }
}

fragment BankAccountVerification_bankAccount on BankAccountNode {
  id
  holderName
  bsbNumber
  accountNumber
  createdAt
  updatedAt
  status
  notes {
    id
  }
  dividendPayout
  account {
    id
    name
  }
  bankaccountdocumentSet {
    edges {
      node {
        id
        file
        fileName
        fileUrl
        updatedAt
        uploadedBy {
          fullName
          id
        }
      }
    }
  }
  approvals {
    edges {
      node {
        id
        approvedBy {
          id
          username
        }
        approvedAt
      }
    }
  }
  hasCompleteApprovals
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "bankAccountId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "dividendPayout",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "bankAccountId",
    "variableName": "bankAccountId"
  },
  {
    "kind": "Variable",
    "name": "dividendPayout",
    "variableName": "dividendPayout"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updatedAt",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BankAccountDividendPayoutUpdateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateBankAccountDividendPayout",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBankAccountDividendPayoutAdmin",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "bankAccount",
            "storageKey": null,
            "args": null,
            "concreteType": "BankAccountNode",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "BankAccountVerification_bankAccount",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BankAccountDividendPayoutUpdateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateBankAccountDividendPayout",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBankAccountDividendPayoutAdmin",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "bankAccount",
            "storageKey": null,
            "args": null,
            "concreteType": "BankAccountNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "holderName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "bsbNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "notes",
                "storageKey": null,
                "args": null,
                "concreteType": "NotesNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "dividendPayout",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "account",
                "storageKey": null,
                "args": null,
                "concreteType": "AccountNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bankaccountdocumentSet",
                "storageKey": null,
                "args": null,
                "concreteType": "BankAccountDocumentNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BankAccountDocumentNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BankAccountDocumentNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "file",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fileName",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fileUrl",
                            "args": null,
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "uploadedBy",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "fullName",
                                "args": null,
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "approvals",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ApprovalNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ApprovalNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "approvedBy",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "username",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "approvedAt",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasCompleteApprovals",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "BankAccountDividendPayoutUpdateMutation",
    "id": null,
    "text": "mutation BankAccountDividendPayoutUpdateMutation(\n  $bankAccountId: ID!\n  $dividendPayout: Boolean!\n) {\n  updateBankAccountDividendPayout(dividendPayout: $dividendPayout, bankAccountId: $bankAccountId) {\n    bankAccount {\n      ...BankAccountVerification_bankAccount\n      id\n    }\n  }\n}\n\nfragment BankAccountVerification_bankAccount on BankAccountNode {\n  id\n  holderName\n  bsbNumber\n  accountNumber\n  createdAt\n  updatedAt\n  status\n  notes {\n    id\n  }\n  dividendPayout\n  account {\n    id\n    name\n  }\n  bankaccountdocumentSet {\n    edges {\n      node {\n        id\n        file\n        fileName\n        fileUrl\n        updatedAt\n        uploadedBy {\n          fullName\n          id\n        }\n      }\n    }\n  }\n  approvals {\n    edges {\n      node {\n        id\n        approvedBy {\n          id\n          username\n        }\n        approvedAt\n      }\n    }\n  }\n  hasCompleteApprovals\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '15a8a6e24f20109fd5db8de532bdb643';
module.exports = node;
